import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import { useTheme } from 'vuetify';
import { useAppStore } from '@/stores/app.store';
import lightModeSvg from '@/assets/img/lightMode.svg';
import darkModeSvg from '@/assets/img/darkMode.svg';
import useSystemSvg from '@/assets/img/useSystem.svg';
import MBtn from '@/components/BaseButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppSettings',
  props: {
    isActive: { type: Boolean, required: true }
  },
  emits: ["closed"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;
const emit = __emit;

const activeDialog = ref(props.isActive);
const prefersDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;

const themes = [
	{ name: 'light', img: lightModeSvg },
	{ name: 'dark', img: darkModeSvg },
	{ name: 'system', img: useSystemSvg }
] as const;

const theme = useTheme();
const appStore = useAppStore();

const selectedTheme = ref(
	themes.find((t) => t.name === appStore.getTheme) ?? themes[0]
);

function closeSettings() {
	activeDialog.value = false;
	emit('closed');
}

function toggleTheme(selection: typeof themes[number]) {
	theme.global.name.value =
		selection.name === 'system'
			? prefersDarkMode
				? 'dark'
				: 'light'
			: selection.name;
	appStore.setTheme(selection.name);
	selectedTheme.value = selection;
}

watch(
	() => props.isActive,
	(newVal) => {
		activeDialog.value = newVal;
	}
);

const __returned__ = { props, emit, activeDialog, prefersDarkMode, themes, theme, appStore, selectedTheme, closeSettings, toggleTheme }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})